module.exports = __webpack_public_path__ + "static/media/vid2.8b1544bb.mp4";